// UploadForm.jsx
import React, { useState } from 'react';
import '../styles/SwordfishTrombone.css';
import '../styles/UploadForm.css';
const UploadForm = ({ onUpload, uploading }) => {
  const [song, setSong] = useState('');
  const [artist, setArtist] = useState('');
  const [email, setEmail] = useState('');
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');
  const [description, setDescription] = useState('');

  const submit = async () => {
    setError('');

    if (!song.trim() || !artist.trim() || !email.trim() || !file) {
      setError('Please fill all fields.');
      return;
    }

    // basic email sanity check (not perfect, but fine for UI)
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    if (!emailOk) {
      setError('Please enter a valid email address.');
      return;
    }

    try {
      await onUpload({
        song: song.trim(),
        artist: artist.trim(),
        email: email.trim(),
        description: description.trim(),
        file
      });

      // clear on success
      setSong('');
      setArtist('');
      setEmail('');
      setFile(null);
      setDescription('');
    } catch (e) {
      console.error(e);
      setError('Upload failed.');
    }
  };

  return (
    <div className="upload-form">
      <h2>Submit Your Version</h2>

      <input
        type="text"
        placeholder="Song title"
        value={song}
        onChange={e => setSong(e.target.value)}
      />
      <input
        type="text"
        placeholder="Artist name"
        value={artist}
        onChange={e => setArtist(e.target.value)}
      />

      <input
        type="email"
        placeholder="Email (for admin only)"
        value={email}
        onChange={e => setEmail(e.target.value)}
        autoComplete="email"
      />

        <input
          type="text"
          placeholder="Description (who’s playing, where it was recorded, etc.)"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

      <input
        type="file"
        accept="audio/*"
        onChange={e => setFile(e.target.files?.[0] || null)}
      />

      {error && <p className="form-error">{error}</p>}

      <button onClick={submit} disabled={uploading}>
        {uploading ? 'UPLOADING...' : 'UPLOAD'}
      </button>
    </div>
  );
};

export default UploadForm;
